import moment from "moment";
import store from "@/store";

export default function (filename: string, filetype: string) {
  const date = moment().format("YYYYMMDD_HHmm");
  return `${store.state.brain}_${date}_${filename}.${filetype}`;
}
